'use client'
import {createContext, useState, useEffect} from 'react'
import { useRouter, useSelectedLayoutSegments } from 'next/navigation'
import { resolveInitialHeaderState } from '@/lib/headerState'

const WebContext = createContext()

/**
 * @param {{ children: React.ReactNode, headerStates?: import('@/lib/headerState').HeaderStatesData | null }} props
 */
export default function WebProvider({children, headerStates = null}) {
    // Los segmentos de ruta salen del árbol del router (idéntico en servidor y
    // cliente), NO de `usePathname()`: en Vercel la home se regenera (ISR) con la URL
    // interna `/index`, así que `usePathname()` devolvía "/index" en SSR y "/" en el
    // cliente → estado inicial del header divergente y DOM bloqueado con fondo blanco.
    const segments = useSelectedLayoutSegments();
    const isHome = segments.length === 0;
    const [pageIsLoaded, setPageIsLoaded] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)
    const router = useRouter();
    // Estado inicial del header calculado en render (también en SSR), no en un effect:
    // se resuelve con la ruta + una tabla mínima del CMS (`headerStates`, ver
    // lib/headerState.ts) para que el HTML ya llegue con el header correcto sobre el
    // hero. Si se inicializara en blanco/negro y el hero lo corrigiera al montar, el
    // cambio se animaría con la transition del header y se vería el parpadeo.
    const [initialHeader] = useState(() => resolveInitialHeaderState(segments, headerStates))
    const [backgroundHeader, setBackgroundHeader] = useState(initialHeader.background)
    const [colorHeader, setColorHeader] = useState(initialHeader.color)
    const [openOverview, setOpenOverview] = useState(false)
    const [pastColorHeader, setPastColorHeader] = useState('black')
    const [pastBackgroundHeader, setPastBackgroundHeader] = useState(true)
    
    

    async function changePageIsLoaded() {
        setPageIsLoaded(true)  
    }

    return (
        <WebContext.Provider
            value={{
                changePageIsLoaded,
                pageIsLoaded,
                menuOpen,
                setMenuOpen,
                colorHeader, 
                setColorHeader,
                backgroundHeader, 
                setBackgroundHeader,
                openOverview, 
                setOpenOverview,
                pastColorHeader, 
                setPastColorHeader,
                pastBackgroundHeader,
                setPastBackgroundHeader,
                isHome
            }}
        >
            {children}
        </WebContext.Provider>
    )
}

const WebConsumer = WebContext.Consumer

export {WebConsumer, WebContext}
